import { useMemo } from 'react'

import { NetWorthShell } from '@/modules/netWorth/pages/components/NetWorthShell/NetWorthShell'

import { NoAccounts } from '@/components/@Shared/NoAccounts/NoAccounts'
import { Loader } from '@/components/Loader/Loader'

import { useBankingServiceBankingControllerGetAccounts } from '@/__generated__/queries'
import type { AccountData } from '@/__generated__/requests/types.gen'

export function Component() {
  const { data, isFetching, isLoading } =
    useBankingServiceBankingControllerGetAccounts()

  const userAccounts = useMemo<AccountData[]>(
    () => data?.accounts ?? [],
    [data],
  )

  if (isLoading || isFetching) {
    return <Loader isAuthenticatedLayout />
  }

  if (userAccounts.length) {
    return <NetWorthShell />
  }

  return <NoAccounts />
}

Component.displayName = 'NetWorth'
